const outofstock = {
    namespaced: true,
    state: {
        formVisibility: false,
        addToCartBtnVisibility: false,
        modalVisibility: false,
        formData: null,
        submitted: false,
        hasOnlineSparePart: false,
        isOnlineSparePartEnabled: false,
    },
    mutations: {
        hideAddToCartButton(state) {
            state.addToCartBtnVisibility = false;
        },
        hideModal(state) {
            state.modalVisibility = false;
        },
        showModal(state, payload) {
            state.modalVisibility = true;
            state.formData = payload;
        },
        formSubmitted(state) {
            state.submitted = true;
        },
        setSparePartAvailability(state, { isOnlineSparePartEnabled, hasOnlineSparePart }) {
            state.hasOnlineSparePart = hasOnlineSparePart;
            state.isOnlineSparePartEnabled = isOnlineSparePartEnabled;
        }
    },
    actions: {
       async sendRequest({ state, commit }, payload) {
            commit('formSubmitted');
            let endpoint = '/' + window.culture + "/api" + '/stock-waitlist';
            let data = {...state.formData, emailOptIn: payload.optIn ? 1 : 0 };
            let response = await axios.post(endpoint, data);
        }
    },
    getters: {
        isAddToCartBtnVisible: state => {
            return state.addToCartBtnVisibility;
        },
        modalVisibility: state => {
            return state.modalVisibility;
        },
        isFormSubmitted: state => {
            return state.submitted;
        }
    }
}

export default outofstock;